export * from './vorlage-sorter.component';
export * from './vorlage-sorter.component.module';